import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';
import { Anchor, Box, Tag, Heading } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import { event } from '@zillow/universal-analytics';
import { getCmsInfoForPage, usePageProps } from '@zillow/zrs-cms';

const StyledAnchor = styled(Anchor)`
    text-decoration: none;
`;

const Tags = ({ postTags }) => {
    const theme = useTheme();
    const pageProps = usePageProps();

    if (!postTags || postTags.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                // Wanted: 32 Found: 32
                padding: `${theme.constellation.spacing.lg}px 0`,
            }}
        >
            <Heading level={5} marginBottom="sm">
                Tags
            </Heading>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    // Wanted: 12 Found: 16 - 16 looks bad so hardcoding 12 (between xs & sm).
                    gap: '12px',
                }}
            >
                {postTags.map((postTag, index) => (
                    <StyledAnchor
                        key={postTag.id}
                        href={postTag.link}
                        onClick={yieldCallback(() => {
                            event({
                                // https://dataportal.zillowgroup.net/event-registry/2048
                                envelope: {
                                    event_type_id: '2048',
                                    event_type_version_id: '1',
                                    event_template_id: '126',
                                    event_template_version_id: '1',
                                    // Master ID: 2284.2.126.1
                                },
                                clickstream_trigger: {
                                    trigger_type_nm: 'interaction',
                                    trigger_location_nm: 'cms',
                                    trigger_source_nm: 'cms_tag',
                                    trigger_object_nm: 'no_trigger_object',
                                },
                                semantic: {
                                    semantic_event_nm: 'cms_click',
                                },
                                cms_info: {
                                    block_id: postTag.id || '',
                                    block_type_cd: 'tag',
                                    block_displayed_txt: postTag.name,
                                    block_target_url: postTag.link,
                                    block_target_window_txt: '',
                                    ...getCmsInfoForPage(pageProps),
                                },
                            });
                        })}
                    >
                        <Tag
                            // It's ok to use index here as this is not going to change.
                            key={index}
                            textTransform="none"
                        >
                            {/* I tried putting dangerouslySetInnerHTML on <Tag>
                             * however I get error saying "can only set children
                             * or html"
                             * */}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: postTag.name,
                                }}
                            />
                        </Tag>
                    </StyledAnchor>
                ))}
            </Box>
        </Box>
    );
};

Tags.propTypes = {
    postTags: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        })
    ),
};

Tags.defaultProps = {
    postTags: undefined,
};

export default Tags;
